/** @format */

import { CartItem } from '../cart/cart.model';

export interface Cart {
  external_key: string;
  external_source: string;

  items: CartItem[];
  messaging: string[];
  paypal_eligible?: boolean;
  scorecardPlusMember?: boolean;
  containsScorecardPlusProduct?: boolean;
}
